import { IWebsiteBuilderNodeDimensions, IWebsiteBuilderNodePosition } from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderNodeGeometry";
import React, { ReactNode, useMemo } from "react";

interface ISectionEntityViewPositionIndicator {
  type: "position";
  position: IWebsiteBuilderNodePosition;
  showOnTop: boolean;
}

interface ISectionEntityViewDimensionsIndicator {
  type: "dimensions";
  dimensions: IWebsiteBuilderNodeDimensions;
  showOnTop: boolean;
}

export type TSectionEntityViewIndicator = ISectionEntityViewPositionIndicator | ISectionEntityViewDimensionsIndicator;

interface ISectionEntityViewIndicatorProps {
  indicator: TSectionEntityViewIndicator;
}

export const SECTION_ENTITY_VIEW_INDICATOR_HEIGHT = 22;
export const SECTION_ENTITY_VIEW_INDICATOR_OFFSET = 3;

export function SectionEntityViewIndicator(props: ISectionEntityViewIndicatorProps) {
  const { indicator } = props;

  const indicatorContent: ReactNode = useMemo(() => {
    if (indicator?.type === "position" && indicator.position) {
      const roundedPosition: IWebsiteBuilderNodePosition = {
        x: Math.round(indicator.position.x),
        y: Math.round(indicator.position.y),
      };

      return <>({roundedPosition.x}, {roundedPosition.y})</>;
    } else if (indicator?.type === "dimensions" && indicator.dimensions) {
      const roundedDimensions: IWebsiteBuilderNodeDimensions = {
        width: Math.round(indicator.dimensions.width),
        height: Math.round(indicator.dimensions.height),
      };

      return <>{roundedDimensions.width} x {roundedDimensions.height}</>;
    } else {
      return null;
    }
  }, [indicator]);

  if (!indicator) {
    return null;
  }

  return (
    <div
      className="website-builder-section-entity-view-indicator"
      style={{
        height: SECTION_ENTITY_VIEW_INDICATOR_HEIGHT,
        top: indicator.showOnTop ? "0" : "100%",
        transform: `translateY(
          ${indicator.showOnTop ? `calc(-100% - ${SECTION_ENTITY_VIEW_INDICATOR_OFFSET}px)` : `${SECTION_ENTITY_VIEW_INDICATOR_OFFSET}px`}
        )`,
      }}
    >
      {indicatorContent}
    </div>
  );
}
